import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";

export const getStageEquipmentKey = (stageId: string | null, category: string) =>
  stageId ? `${API_ENDPOINTS.STAGE(stageId)}/${category}` : category;

export const getEquipmentKey = (venueId: string) =>
  `${API_ENDPOINTS.VENUE(venueId)}/${IDataKeys.equipment}`;

export const getEquipmentCategoriesKey = (stageId: string | null, category: string) =>
  stageId ? `${API_ENDPOINTS.VENUE(stageId)}/equipmentCategories/${category}` : category;
